import React, { useRef } from 'react'
import { Button } from 'semantic-ui-react'
import CustomPopup from '../../../commonComponents/customPopup'
import ListOfDocuments from './listOfDocuments'

const UploadDocuments = () => {
  const popup = useRef()
  return (
    <div className='exchangeRates'>
      <Button
        // style={{marginRight:'20px'}}  will do if needed
        size='mini'
        className='sv todo-button'
        onClick={() => {
          popup.current?.openPopup()
        }}
      >
        FILE UPLOAD
      </Button>
  
      <CustomPopup
        // closeIcon
        // onClose={() => popup.current?.closePopup()}
        content={true}
        description={
          <ListOfDocuments onClose={popup.current?.closePopup} />
        }
        ref={popup}
        className='fileUploadPopup'
      />
    </div>
  )
}

export default UploadDocuments
